import type RootStore from "stores/RootStore";
import type { RouteType } from "types/RouteType";
import type ReceivablesStore from "./ReceivablesStore";
import { ALL_CLIENTS } from "./receivables.types";

const storeOf = (rootStore: RootStore) =>
  (rootStore as unknown as { receivablesViewStore?: ReceivablesStore }).receivablesViewStore;

/**
 * Billing → Receivables: what every client owes, how overdue, and what has
 * been paid (Blake's AR tracker in HQ, #3075 / #2663). Gated by
 * gateBillingRoutes like every billing page, and `requiresAdmin` like the
 * Invoices page beside it — the API's admin-or-finance rule is the authority.
 */
const receivablesRoute: RouteType[] = [
  {
    name: "Receivables",
    path: "/billing/receivables",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Receivables",
        component: () => import("./Receivables.Header"),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: { component: () => import("./Receivables.Body") },
    },
    group: "Billing",
    searchAliases: ["accounts receivable", "ar", "aging", "owed", "overdue invoices", "payments received"],
    hidden: false,
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    enableAutoFind: false,
    onEnter: async ({ rootStore }) => {
      void storeOf(rootStore)?.initialize(ALL_CLIENTS);
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default receivablesRoute;
